const REDACT_QUERY_KEY = 'redact';

/** True when `?redact=1` (or any truthy value) is present — for marketing/docs screenshots. */
export function isParaScreenshotRedactEnabled(search = window.location.search): boolean {
	const value = new URLSearchParams(search).get(REDACT_QUERY_KEY);
	if (value == null) return false;
	const normalized = value.trim().toLowerCase();
	return normalized === '' || normalized === '1' || normalized === 'true' || normalized === 'yes';
}

/** Toggles `html.para-screenshot-redact` so global CSS can blur `[data-para-redact]` nodes. */
export function syncParaScreenshotRedactDocumentClass(search = window.location.search): void {
	const root = document.documentElement;
	if (isParaScreenshotRedactEnabled(search)) {
		root.classList.add('para-screenshot-redact');
	} else {
		root.classList.remove('para-screenshot-redact');
	}
}
